export default "__VITE_ASSET__BryNF0pQ__"